// hooks/useAppRole.ts
import { useAuth } from '../contexts/AuthContext';

export function useAppRole(requiredRoles: string | string[]) {
  const { user } = useAuth();

  let roles: string[] = [];
  if (user?.idTokenClaims?.roles) {
    if (Array.isArray(user.idTokenClaims.roles)) {
      roles = user.idTokenClaims.roles;
    } else if (typeof user.idTokenClaims.roles === 'string') {
      roles = [user.idTokenClaims.roles];
    }
  } else if (user?.idTokenClaims?.role) {
    if (Array.isArray(user.idTokenClaims.role)) {
      roles = user.idTokenClaims.role;
    } else if (typeof user.idTokenClaims.role === 'string') {
      roles = [user.idTokenClaims.role];
    }
  }
  const required = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  const hasRole = required.some(role => roles.includes(role));

  return hasRole;
}